import { motion } from 'framer-motion';

export default function AdBanner() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="bg-gradient-to-r from-purple-600 to-pink-600 text-white py-12 mt-16"
    >
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="text-center md:text-left">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Discover More Names & Meanings
          </h2>
          <p className="text-purple-100 max-w-xl">
            Explore our premium features to find deeper meanings, compatibility matches,
            and personalized name recommendations.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="/premium"
            className="px-6 py-3 bg-white text-purple-600 rounded-lg font-medium hover:bg-purple-50 transition-colors text-center"
          >
            Try Premium
          </a>
          <a
            href="/contact"
            className="px-6 py-3 bg-purple-700 text-white rounded-lg font-medium hover:bg-purple-800 transition-colors text-center"
          >
            Contact Us
          </a>
        </div>
      </div>
    </motion.div>
  );
}